export const mockSportsMarkets = [
  {
    id: 'nba-lakers-warriors',
    sport: 'NBA',
    isLive: true,
    volume: '$1.2m Vol.',
    teams: [
      {
        id: 'lakers',
        name: 'Lakers',
        abbreviation: 'LAL',
        seed: 2,
        price: 0.58,
        color: '#552583',
      },
      {
        id: 'warriors',
        name: 'Warriors',
        abbreviation: 'GSW',
        seed: 1,
        price: 0.42,
        color: '#1D428A',
      },
    ],
  },
  {
    id: 'nfl-chiefs-bills',
    sport: 'NFL',
    isLive: false,
    volume: '$3.5m Vol.',
    teams: [
      {
        id: 'chiefs',
        name: 'Chiefs',
        abbreviation: 'KC',
        seed: 1,
        price: 0.72,
        color: '#E31837',
      },
      {
        id: 'bills',
        name: 'Bills',
        abbreviation: 'BUF',
        seed: 2,
        price: 0.28,
        color: '#00338D',
      },
    ],
  },
];
